class PersonalInfoForm {
  constructor(data) {
    const { profile } = data;
    this.firstName = (profile && profile.firstName) || "";
    this.lastName = (profile && profile.lastName) || "";
    this.email = (profile && profile.email) || "";
    this.phone = (profile && profile.phone) || "";
    this.birthday = (profile && profile.birthday) || "";
    this.avatar_image = (profile && profile.avatarImage) || "";
    (this.address = {
      address_line_1: (profile && profile.address && profile.address.addressLine1) || "",
      address_line_2: (profile && profile.address && profile.address.addressLine2) || "",
      city: (profile && profile.address && profile.address.city) || "",
      zip: (profile && profile.address && profile.address.zip) || ""
    }),
      (this.newPassword = "");
  }
}

export default PersonalInfoForm;
